import { createAction } from 'redux-actions'

export const signup = createAction('SIGNUP')
export const signupStart = createAction('SIGNUP_START')
export const signupSuccess = createAction('SIGNUP_SUCCESS')
export const signupError = createAction('SIGNUP_ERROR')
export const resetRedirectTo = createAction('SIGNUP_RESET_REDIRECT_TO')



// WEBPACK FOOTER //
// ./src/services/signup/actions.js